"use client";

import AlarmClock from "./AlarmClock.jsx";
import Apple from "./Apple.jsx";
import AppleStore from "./AppleStore.jsx";
import BabyBoy from "./BabyBoy.jsx";
import BabyFeeder from "./BabyFeeder.jsx";
import BabyGirl from "./BabyGirl.jsx";
import BasketBall from "./BasketBall.jsx";
import BeautyProducts from "./BeautyProducts.jsx";
import Beer from "./Beer.jsx";
import Bottle from "./Bottle.jsx";
import Breakfast from "./Breakfast.jsx";
import Camera from "./Camera.jsx";
import Car from "./Car.jsx";
import Carrot from "./Carrot.jsx";
import CartIcon from "./Cart.jsx";
import CartBag from "./CartBag.jsx";
import CartCheck from "./CartCheck.jsx";
import CartX from "./CartX.jsx";
import Category from "./Category.jsx";
import CategoryOutlined from "./CategoryOutline.jsx";
import CreditCardVerified from "./CreditCardVerified.jsx";
import CustomerService from "./CustomerService.jsx";
import Delivery from "./Delivery.jsx";
import DeliveryBox from "./DeliveryBox.jsx";
import DottedStar from "./DottedStar.jsx";
import Dress from "./Dress.jsx";
import DrillMachine from "./DrillMachine.jsx";
import Eye from "./Eye.jsx";
import Facebook from "./Facebook.jsx";
import FacebookFilled from "./FacebookFilled.jsx";
import FeedbackThumbsUp from "./FeedbackThumbsUp.jsx";
import Figma from "./Figma.jsx";
import Food from "./Food.jsx";
import Gift from "./Gift.jsx";
import GiftBox from "./GiftBox.jsx";
import Globe from "./Globe.jsx";
import GoldPackageIcon from "./GoldPackageIcon.jsx";
import Google from "./Google.jsx";
import Heart from "./Heart.jsx";
import Honey from "./Honey.jsx";
import Instagram from "./Instagram.jsx";
import InstagramFilled from "./InstagramFilled.jsx";
import Laptop from "./Laptop.jsx";
import Light from "./Light.jsx";
import Lightning from "./Lightning.jsx";
import MakeUp from "./MakeUp.jsx";
import Man from "./Man.jsx";
import Microphone from "./Microphone.jsx";
import Milk from "./Milk.jsx";
import MoneyGuarantee from "./MoneyGurantee.jsx";
import MotorBike from "./MotorBike.jsx";
import NewArrival from "./NewArrival.jsx";
import OnlineService from "./OnlineService.jsx";
import OnlineSupport from "./OnlineSupport.jsx";
import PackageBox from "./PackageBox.jsx";
import Payment from "./Payment.jsx";
import Pen from "./Pen.jsx";
import Pets from "./Pets.jsx";
import PickUpBox from "./PickUpBox.jsx";
import Picture from "./Picture.jsx";
import PlantPot from "./PlantPot.jsx";
import PlayStore from "./PlayStore.jsx";
import PremiumPackageIcon from "./PremiumPackageIcon.jsx";
import Preview from "./Preview.jsx";
import Quote from "./Quote.jsx";
import RankBadge from "./RankBadge.jsx";
import Reload from "./Reload.jsx";
import Search from "./Search.jsx";
import Shield from "./Shield.jsx";
import ShoppingBagOutlined from "./ShoppingBagOutlined.jsx";
import SilverPackageIcon from "./SilverPackageIcon.jsx";
import Snack from "./Snack.jsx";
import SofaTwo from "./Sofa.jsx";
import Telegram from "./Telegram.jsx";
import Toggle from "./Toggle.jsx";
import Truck from "./Truck.jsx";
import TruckFast from "./TruckFast.jsx";
import TruckFilled from "./TruckFilled.jsx";
import Tshirt from "./Tshirt.jsx";
import Twitter from "./Twitter.jsx";
import TwitterFilled from "./TwitterFilled.jsx";
import UpDown from "./UpDown.jsx";
import User from "./User.jsx";
import User2 from "./User2.jsx";
import Verify from "./Verify.jsx";
import Vest from "./Vest.jsx";
import Watch from "./Watch.jsx";
import Wheel from "./Wheel.jsx";
import Woman from "./Woman.jsx";
import WomenDress from "./WomenDress.jsx";
import Yogurt from "./Yogurt.jsx";
import Youtube from "./Youtube.jsx";
import YoutubeFilled from "./YoutubeFilled.jsx";
// furniture shop page icons

import Home from "./Home.jsx";
import Sofa from "./furniture-shop/Sofa.jsx";
import Chair from "./furniture-shop/Chair.jsx";
import Stool from "./furniture-shop/Stool.jsx";
import Dining from "./furniture-shop/Dining.jsx";
import Living from "./furniture-shop/Living.jsx";
import Popular from "./furniture-shop/Popular.jsx";
import RoomSet from "./furniture-shop/RoomSet.jsx";
import Trending from "./furniture-shop/Trending.jsx";
import Products from "./furniture-shop/Products.jsx";
import Interior from "./furniture-shop/Interior.jsx";
import Wardrobe from "./furniture-shop/Wardrobe.jsx";
import Furniture from "./furniture-shop/Furniture.jsx";
import Decoration from "./furniture-shop/Decoration.jsx";
import RoundTable from "./furniture-shop/RoundTable.jsx";
// gift shop page icon

import Toys from "./gift-shop/Toys.jsx";
import Robot from "./gift-shop/Robot.jsx";
import Flower from "./gift-shop/Flower.jsx";
import Children from "./gift-shop/Children.jsx";
import BabyToys from "./gift-shop/BabyToys.jsx";
import Football from "./gift-shop/Football.jsx";
import Christmas from "./gift-shop/Christmas.jsx";
import TeddyBear from "./gift-shop/TeddyBear.jsx";
import WeddingGift from "./gift-shop/WeddingGift.jsx";
import NewYearGift from "./gift-shop/NewYearGift.jsx";
import BirthdayCake from "./gift-shop/BirthdayCake.jsx";
import ValentineGift from "./gift-shop/ValentineGift.jsx";
// health and beauty homepage icons

import Powder from "./health-and-beauty/Powder.jsx";
import Lotion from "./health-and-beauty/Lotion.jsx";
import Mascara from "./health-and-beauty/Mascara.jsx";
import Lipstick from "./health-and-beauty/Lipstick.jsx";
import FaceMask from "./health-and-beauty/FaceMask.jsx";
import LenseCase from "./health-and-beauty/LenseCase.jsx";
import AutoMotive from "./health-and-beauty/Automotive.jsx";
import OxygenPump from "./health-and-beauty/OxygenPump.jsx";
import Thermometer from "./health-and-beauty/Thermometer.jsx";
import HealthBeauty from "./health-and-beauty/HealthBeauty.jsx";
const appIcons = {
  Beer,
  Milk,
  Snack,
  Truck,
  Honey,
  Apple,
  Shield,
  Bottle,
  Carrot,
  Yogurt,
  Payment,
  PickUpBox,
  Breakfast,
  AlarmClock,
  OnlineSupport,
  OnlineService,
  MoneyGuarantee,
  CustomerService,
  FeedbackThumbsUp,
  CreditCardVerified,

// furniture-shop-icons
  Home,
  Sofa,
  Chair,
  Stool,
  Dining,
  Living,
  Popular,
  RoomSet,
  Trending,
  Products,
  Interior,
  Wardrobe,
  Furniture,
  Decoration,
  RoundTable,

// gift-shop-page-icons
  Toys,
  Robot,
  Flower,
  BabyToys,
  Children,
  Football,
  Chirstmas: Christmas,
  TeddyBear,
  WeddingGift,
  NewYearGift,
  BirthdayCake,
  ValentineGift,

// health-and-beauty-page-icons
  Powder,
  Lotion,
  Mascara,
  Lipstick,
  FaceMask,
  LenseCase,
  OxygenPump,
  AutoMotive,
  Thermometer,
  HealthBeauty,
  Car,
  Watch,
  Wheel,
  Camera,
  Tshirt,
  BabyBoy,
  Picture,
  BabyGirl,
  WomenDress,
  AppleStore,
  BabyFeeder,
  BasketBall,
  DrillMachine,
  BeautyProducts,
  CartIcon,
  CartCheck,
  CartX,
  Category,
  CategoryOutlined,
  Delivery,
  DeliveryBox,
  DottedStar,
  Dress,
  Eye,
  Facebook,
  FacebookFilled,
  Figma,
  Food,
  Gift,
  Globe,
  GoldPackageIcon,
  Google,
  GiftBox,
  Heart,
  Instagram,
  InstagramFilled,
  Laptop,
  Light,
  Lightning,
  MakeUp,
  Man,
  Microphone,
  MotorBike,
  NewArrival,
  PackageBox,
  Pen,
  Pets,
  PlantPot,
  PlayStore,
  PremiumPackageIcon,
  Preview,
  Quote,
  RankBadge,
  Reload,
  ShoppingBagOutlined,
  SilverPackageIcon,
  SofaTwo,
  Telegram,
  Toggle,
  TruckFast,
  TruckFilled,
  Twitter,
  TwitterFilled,
  UpDown,
  User2,
  Verify,
  Vest,
  Woman,
  Youtube,
  YoutubeFilled,
  Search,
  User,
  CartBag
};
export default appIcons;
